import { Button, Stack } from "@mui/joy"
import React, { useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"


export default function Paginacao(props) {
    useEffect(() => {
        console.log("Pagina atual", props.paginaAtual);
        console.log("Total de páginas", props.totalPaginas);
    }, [props.paginaAtual, props.totalPaginas]);
    return (
        <Stack flexDirection={"row"} alignItems={"center"}>
            {/* Botão anterior */}
            {props.paginaAtual > 1 &&
                <Button
                    variant="plain"
                    sx={{ borderRadius: "100%" }}
                    onClick={() => props.alterarPagina(null, props.paginaAtual - 1)}
                >
                    <FaChevronLeft size={12} />
                </Button>
            }

            <Stack flexDirection={"row"} alignItems={"center"}>
                {Array.from({ length: props.totalPaginas }, (_, i) => i + 1)
                    .filter((pagina) => {
                        // Sempre mostra primeira e última página
                        if (pagina === 1 || pagina === props.totalPaginas) return true;

                        // Mostra páginas dentro da "janela" de ±2
                        if (
                            pagina >= Number(props.paginaAtual) - 2 &&
                            pagina <= Number(props.paginaAtual) + 2
                        ) {
                            return true;
                        }

                        return false;
                    })
                    .map((pagina, index, arr) => {
                        const prev = arr[index - 1];

                        // Se tiver quebra grande, insere reticências
                        if (index > 0 && pagina - prev > 1) {
                            return (
                                <React.Fragment key={pagina}>
                                    <Button variant="plain" disabled sx={{ padding: "0px 10px" }}>
                                        ...
                                    </Button>
                                    <Button
                                        // color="neutral"
                                        onClick={() => props.alterarPagina(null, pagina)}
                                        variant={pagina === Number(props.paginaAtual) ? "solid" : "plain"}
                                        sx={{ padding: "0px 15px" }}
                                    >
                                        {pagina}
                                    </Button>
                                </React.Fragment>
                            );
                        }

                        return (
                            <Button
                                key={pagina}
                                // color="neutral"
                                onClick={() => props.alterarPagina(null, pagina)}
                                variant={pagina === props.paginaAtual ? "solid" : "plain"}
                                sx={{ padding: "0px 15px" }}
                            >
                                {pagina}
                            </Button>
                        );
                    })}
            </Stack>

            {/* Botão próximo */}
            {props.paginaAtual < props.totalPaginas &&
                <Button
                    variant="plain"
                    sx={{ borderRadius: "100%" }}
                    disabled={props.paginaAtual === props.totalPaginas}
                    onClick={() => props.alterarPagina(null, props.paginaAtual + 1)}
                >
                    <FaChevronRight size={12} />
                </Button>
            }
        </Stack>
    )
}